import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Disclosure from './Disclosure';
import { BLOCKS, SCORE_MAX, SCORE_MIN } from './CreditScoreConstants';
import {
  Block,
  Blocks,
  Description,
  Label,
  Needle,
  CreditScoreEmpty,
  RightLabel,
  StyledScore,
  Value,
  Wrapper,
} from './CreditScoreStyles';

const Score = ({ score, rating }) => {
  const percentScore = ((score - SCORE_MIN) / (SCORE_MAX - SCORE_MIN)) * 100;

  return (
    <StyledScore percentScore={percentScore}>
      <Value>{score}</Value>
      <Description>{rating}</Description>
      <Needle percentScore={percentScore} />
    </StyledScore>
  );
};

Score.propTypes = {
  score: PropTypes.number.isRequired,
  rating: PropTypes.string.isRequired,
};

const CreditScore = ({ score, rating }) => {
  const [stateScore, setStateScore] = useState(600);
  const [stateRating, setStateRating] = useState('----');

  // Used here to animate the score
  useEffect(() => {
    setStateScore(score);
    setStateRating(rating);
  }, [score, rating, setStateScore, setStateRating]);

  if (!score) {
    return <CreditScoreEmpty>You currently do not have a credit score</CreditScoreEmpty>;
  }

  return (
    <>
      <Wrapper>
        <Blocks>
          <Score score={stateScore} rating={stateRating} />
          {BLOCKS.map(({ id, color, label, rightLabel }, index) => (
            <Block key={id} color={color}>
              <Label isFirst={index === 0}>{label}</Label>
              {index === BLOCKS.length - 1 && <RightLabel>{rightLabel}</RightLabel>}
            </Block>
          ))}
        </Blocks>
      </Wrapper>
      <Disclosure />
    </>
  );
};

CreditScore.propTypes = {
  score: PropTypes.number.isRequired,
  rating: PropTypes.string.isRequired,
};

export default CreditScore;
